export default "__VITE_ASSET__CsGhbJ6u__"